import script from "./ModalFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFilters.vue?vue&type=script&setup=true&lang=js"

import "./ModalFilters.vue?vue&type=style&index=0&id=a9156654&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9156654"]])

export default __exports__